const actions = {
  ADD_LIVE_LOG: 'logger/ADD_LIVE_LOG',
}

export default actions
